import { withStyles } from '@material-ui/core';
import SearchBar from './SearchBar';
import styles from './styles';


export default withStyles(styles)(SearchBar);
